module.exports = __webpack_public_path__ + "img/install_theme_icon_2.ebb62917.png";